<style scoped>
.title {
  font-size: 24px !important;
}

.phone-button .svg-inline--fa {
  font-size: 16px !important;
}
</style>

<template>
  <div v-if="entity">
    <entity-approved :entity="entity" v-if="approvedEntity"/>
    <entity-pending :entity="entity" :needed-docs="neededDocs" v-else/>
  </div>
</template>

<script>
import helper from '@/libs/helper';

import EntityApproved from '@/components/entities/EntityApproved';
import EntityPending from '@/components/entities/EntityPending';
import { ENTITY_DOC_READ } from '@/libs/permissions_list';

import { library } from '@fortawesome/fontawesome-svg-core';
import { faPhone, faCalendarDay, faFileInvoice } from '@fortawesome/free-solid-svg-icons';


library.add([faPhone, faCalendarDay, faFileInvoice]);


export default {
  components: {
    EntityPending,
    EntityApproved,
  },
  props: {
    entity: Object,
  },
  data() {
    return {
      show: false,
      permissionList: [ENTITY_DOC_READ],
    };
  },
  computed: {
    hasPhone() {
      return (
        this.entity &&
        this.entity.phone &&
        this.entity.phone !== ''
      );
    },
    formattedPhone() {
      return this.hasPhone ? helper.phoneMask(this.entity.phone) : '';
    },
    neededDocs() {
      return this.entity.docs.filter(doc => doc.neededCount !== 0).map(({ type }) => type);
    },
    approvedEntity() {
      return this.neededDocs.length === 0;
    },
  },
  methods: {
    open() {
      this.show = true;
    },
    close() {
      this.show = false;
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/entities/EntityDetails.vue